// extracted by mini-css-extract-plugin
module.exports = {"settingsForm":"drawer_settingsForm__3ZNma","dropdownLanguages":"drawer_dropdownLanguages__3_ySj"};